import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./translations/en.json";
import es from "./translations/es.json";
import de from "./translations/de.json";
import nl from "./translations/nl.json";
import pt from "./translations/pt.json";
import fr from "./translations/fr.json";

const resources = {
    en: {
        translation: en
    },
    es: {
        translation: es
    },
    de: {
        translation: de
    },
    nl: {
        translation: nl
    },
    pt: {
        translation: pt
    },
    fr: {
        translation: fr
    }
};

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: "en",

        interpolation: {
            escapeValue: false
        }
    });

export default i18n;
